export const PRODUCTS = {
  all: 'All Products',
  addon: 'Add-on',
  bedbank: 'Lux Partner Property',
  bedbank_marriott: 'Limited Time Lux Partner',
  booking_protection: 'Refund Protect',
  bundle: 'Bundle and Save',
  car_hire: 'Car Hire',
  cfmr: 'Cancel For Many Reasons',
  cruise: 'Cruise',
  cruisebank: 'Cruisebank',
  custom_offer: 'Custom Offer',
  custom_offer_cruise: 'Custom Offer - Cruise',
  custom_offer_experience: 'Custom Offer - Experience',
  custom_offer_hotel: 'Custom Offer - Hotel',
  custom_offer_other: 'Custom Offer - Other',
  custom_offer_tour: 'Custom Offer - Tour',
  dby_exp: 'Derbysoft',
  flight: 'Flight',
  hotel: 'Limited Time Lux Exclusive',
  insurance: 'Insurance',
  last_minute_hotel: 'Last Minute Hotel',
  led_exp: 'Lux Everyday',
  luxury_plus: 'LuxPlus+',
  merchant_fee: 'Merchant Fee',
  mus_exp: 'Musement',
  ofl_flight: 'Offline Flight',
  rental: 'Rental',
  rez_exp: 'Rezdy',
  service_fee: 'Service Fee',
  tactical_ao_hotel: 'Lux Premium Collection',
  tour: 'Tour',
  tour_optional_experience: 'Tour Optional Experience',
  tourbank: 'Tourbank',
} as const;
